import { env } from '@/config/env';

export const UNDELETED_SLUGS = ['discounts/*', 'categories/*', 'category/*', 'product/*', 'home'];
export const META_TAGS_INSTRUCTION_LINK = `${env.API_URL}/storage/import/meta_tags_instructions.pdf`;

export const GENERAL_PARAMS_OPTIONS = [
  {
    key: 'country',
    label: '{{country}}',
    value: 'country}}',
  },
  {
    key: 'region',
    label: '{{region}}',
    value: 'region}}',
  },
  {
    key: 'city',
    label: '{{city}}',
    value: 'city}}',
  },
  {
    key: 'current_date',
    label: '{{current_date}}',
    value: 'current_date}}',
  },
  {
    key: 'site_name',
    label: '{{site_name}}',
    value: 'site_name}}',
  },
];

export const CATEGORIES_PARAMS_OPTIONS = [
  {
    key: 'category_name',
    label: '{{category_name}}',
    value: 'category_name}}',
  },
  {
    key: 'parent_category',
    label: '{{parent_category}}',
    value: 'parent_category}}',
  },
  {
    key: 'category_description',
    label: '{{category_description}}',
    value: 'category_description}}',
  },
  {
    key: 'filter_alias_name',
    label: '{{filter_alias_name}}',
    value: 'filter_alias_name}}',
  },
];

export const PRODUCT_PARAMS_OPTIONS = [
  {
    key: 'product_name',
    label: '{{product_name}}',
    value: 'product_name}}',
  },
  {
    key: 'original_price',
    label: '{{original_price}}',
    value: 'original_price}}',
  },
  {
    key: 'discount_percentage',
    label: '{{discount_percentage}}',
    value: 'discount_percentage}}',
  },
  {
    key: 'discount',
    label: '{{discount}}',
    value: 'discount}}',
  },
  {
    key: 'sale_price',
    label: '{{sale_price}}',
    value: 'sale_price}}',
  },
  {
    key: 'price_range',
    label: '{{price_range}}',
    value: 'price_range}}',
  },
  {
    key: 'availability',
    label: '{{availability}}',
    value: 'availability}}',
  },
  {
    key: 'sku',
    label: '{{sku}}',
    value: 'sku}}',
  },
  {
    key: 'filter_alias_name',
    label: '{{filter_alias_name}}',
    value: 'filter_alias_name}}',
  },
  {
    key: 'filter_alias_value',
    label: '{{filter_alias_value}}',
    value: 'filter_alias_value}}',
  },
];

export enum MetaTagHints {
  GENERAL = 'general',
  CATEGORIES = 'categories',
  PRODUCTS = 'products',
}

export const checkPath = (slug: string) => {
  if (slug?.startsWith('product/')) {
    return MetaTagHints.PRODUCTS;
  }

  if (slug?.startsWith('category/') || slug?.startsWith('categories/')) {
    return MetaTagHints.CATEGORIES;
  }

  return MetaTagHints.GENERAL;
};

export const META_TAG_PARAMETERS = {
  [MetaTagHints.GENERAL]: GENERAL_PARAMS_OPTIONS,
  [MetaTagHints.CATEGORIES]: [...GENERAL_PARAMS_OPTIONS, ...CATEGORIES_PARAMS_OPTIONS],
  [MetaTagHints.PRODUCTS]: [...GENERAL_PARAMS_OPTIONS, ...PRODUCT_PARAMS_OPTIONS],
};

export const getMetaTagsParamsOptions = (hint: MetaTagHints) => META_TAG_PARAMETERS[hint];
